import './css/Logo.css';

function Logo() {
    return (
        <div className="container-logo">
            <span className="logo-item1">
                {"</>"}
            </span>
            <span className="logo-item2">
                {"tiago"}
            </span>
            <span className="logo-item3">
                {"lucas"}
            </span>
            <span className="logo-item4">
                •
            </span>
        </div>
    );    
}

export default Logo;